<template>
  <div :class="classes">
    <v-icon icon="spinner" :ratio="ratio"></v-icon>
  </div>
</template>

<script>
import VIcon from "../icon/Icon.vue";

export default {
  name: "v-spinner",
  components: {
    VIcon
  },
  props: {
    ratio: { type: Number, default: 1 }
  },
  computed: {
    classes() {
      return ["v-spinner"];
    }
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";

.v-spinner {
  stroke: map-deep-get($colors, "foreground", "action");
  stroke-dashoffset: 0;
  stroke-dasharray: 45;
  transform-origin: center center;
  backface-visibility: hidden;
  animation: spin cubic-bezier(0.62, 0.63, 0, 0.53) 800ms infinite;
  display: inline-block;

  .v-icon {
    svg {
      circle {
        fill: none;
      }
    }
  }
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
